import React from 'react';

import {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import {DetailPageRelatedTasksSidebar} from 'app/components/general/DetailPageRelatedTasksSidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectTasksURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {
  ProcedureHashidSerializedType,
  ProcessHashidSerializedType,
} from 'sweet-types';

function TasksPanelContent<
  ItemType extends ProcedureHashidSerializedType | ProcessHashidSerializedType
>({object, legacyRefetch}: LeftSidebarPanelType<ItemType>) {
  return (
    <DetailPageRelatedTasksSidebar
      objectId={object.id}
      html_url={object.html_url}
      contentType={object.content_type}
      onChange={legacyRefetch}
      canAssign={object.can_assign}
    />
  );
}

function TasksMenuButton<
  ItemType extends ProcedureHashidSerializedType | ProcessHashidSerializedType
>({
  object,
  hideTooltip,
  forceTooltipShow,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType('tasktemplate');
  return (
    <SidebarItem
      title={gt('Related tasks')}
      active={active}
      icon={contentType.icon}
      badge={object.task_count > 0 ? object.task_count : undefined}
      link={getObjectTasksURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const TasksSidebar: LeftSidebarElementType<
  ProcedureHashidSerializedType | ProcessHashidSerializedType
> = {
  Panel: TasksPanelContent,
  MenuButton: TasksMenuButton,
  type: 'left',
  sidebarName: 'showTasks',
};
